import React, { useState } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Alert, Box, Button, Link, Stack, TextField, Typography } from '@mui/material';
import { PortalApi } from './portalApi';
import { portalErrorMessage } from './portalHttp';

// ---- P1-B customer portal ----
const ForgotPassword: React.FC = () => {
  const { code = '' } = useParams<{ code: string }>();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await PortalApi.forgotPassword(code, email.trim());
      setSent(true);
    } catch (err) {
      setError(portalErrorMessage(err, 'Something went wrong. Try again in a moment.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box component="form" onSubmit={submit}>
      <Typography variant="h6" gutterBottom>Forgot your password?</Typography>
      <Stack spacing={2}>
        <Alert severity="info">
          If the business that invited you has not switched on portal e-mails, ask its accounts team for a reset link.
        </Alert>
        {sent && <Alert severity="success">If that e-mail has an active portal account and portal e-mails are on, a reset link is on its way.</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        <TextField label="E-mail" type="email" required fullWidth value={email} onChange={e => setEmail(e.target.value)} />
        <Button type="submit" variant="contained" disabled={busy || !email.trim()}>Send reset link</Button>
        <Link component={RouterLink} to={`/portal/${encodeURIComponent(code)}/login`} variant="body2">Back to sign in</Link>
      </Stack>
    </Box>
  );
};

export default ForgotPassword;
// ---- end P1-B ----
